module.exports = __webpack_public_path__ + "img/lazy.1a4b52ab.jpg";